import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faCheck, faPlus } from "@fortawesome/free-solid-svg-icons";
import { displayName } from "./hooks/useAssignments";

const VariantBuilderAssignmentDropdown = React.forwardRef((props, ref) => {
  const {
    canAssign,
    loading,
    pool,
    query,
    setQuery,
    filteredUsers,
    usersById,
    isAssigned,
    toggle,
    showInviteLink,
    onInvite,
  } = props;

  return (
    <div
      ref={ref}
      className="absolute top-full right-0 mt-1 w-80 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden shadow-lg z-50 text-left"
    >
      <div className="px-3 py-2 border-b border-slate-100 dark:border-slate-800 text-xl font-semibold text-slate-700 dark:text-gray-200">
        Assign Users
      </div>

      {!loading && pool.length > 0 && (
        <div className="px-3 py-2 border-b border-slate-100 dark:border-slate-800">
          <div className="relative">
            <span className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400">
              <FontAwesomeIcon icon={faSearch} className="text-lg" />
            </span>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search users…"
              autoFocus
              className="w-full pl-8 pr-2 py-2 text-lg rounded-lg text-slate-500 bg-white dark:bg-slate-950 border-none focus:border-none focus:outline-none"
            />
          </div>
        </div>
      )}

      {loading && (
        <div className="px-3 py-3 text-lg text-slate-500">Loading…</div>
      )}

      {!loading && (
        <div className="max-h-[400px] overflow-y-auto">
          {filteredUsers.map((user) => {
            const checked = isAssigned(user.id);
            return (
              <div
                key={user.id}
                className={`flex items-center gap-2 px-3 py-2 text-lg ${
                  canAssign ? "cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800" : ""
                }`}
                onClick={() => toggle(user)}
              >
                <div className="w-[24px] h-[24px] overflow-hidden rounded-full shrink-0">
                  <img src={user.avatar} alt={displayName(user)} className="w-full h-auto" />
                </div>
                <span className="flex-1 truncate text-slate-700 dark:text-gray-200">
                  {displayName(user)}
                </span>
                {checked && (
                  <FontAwesomeIcon icon={faCheck} className="text-blue-600" />
                )}
              </div>
            );
          })}

          {usersById.size === 0 && (
            <div className="px-3 py-3 text-lg text-slate-500">
              {canAssign ? "No users available." : "No one has access yet."}
            </div>
          )}

          {usersById.size > 0 && filteredUsers.length === 0 && (
            <div className="px-3 py-3 text-lg text-slate-500">
              No users found.
            </div>
          )}
        </div>
      )}

      {showInviteLink && (
        <div
          className="flex items-center gap-2 px-3 py-2 text-lg border-t border-slate-100 dark:border-slate-800 cursor-pointer text-blue-600 hover:bg-slate-50 dark:hover:bg-slate-800"
          onClick={onInvite}
        >
          <FontAwesomeIcon icon={faPlus} />
          <span>Invite new user</span>
        </div>
      )}
    </div>
  );
});

export default VariantBuilderAssignmentDropdown;
